<template>
	<li class="express-type-freight clearfix">
		<div class="type"><div class="ui-ico-sfi" >{{_ll('顺丰标快')}}</div></div>
		<div class="type"><p class="hard">{{this.$store.state.payFee.weight}}kg</p></div>
		<div class="type"><p class="hard">{{_ll('约2-4个工作日')}}</p></div>
		<div class="type"><p class="hot">{{_ll('以收派员巴枪价格为准')}}</p></div>
		</li>
</template>

<script>
    export default {
        name: "PayFeeDefaultProduct"
    }
</script>

<style scoped>
	.clearfix {
		zoom: 1;
	}
	li:first-child {
		border-top: 0;
	}
	li {
		list-style: none;
		background-color: #fff;
		border-bottom: #ddd 1px solid;
	}
	.type {
		display: inline-block;
		float: left;
		color: #333;
		word-break: break-all;
	}
	.express-type-freight{
		padding: 10px;
		overflow: hidden;
	}
	.express-type-freight .type:nth-of-type(1) {
		width: 30%;
	}
	.express-type-freight .type:nth-of-type(2) {
		width: 20%;
	}
	.express-type-freight .type:nth-of-type(3) {
		width: 30%;
	}
	.ui-ico-sfi {
		display: inline-block;
		background-repeat: no-repeat;
		vertical-align: middle;
	}
	.hard {
		color: #333;
	}
	.hot {
		color: #ed2210;
	}
</style>



// WEBPACK FOOTER //
// src/pages/payFee/pay-fee-default-product.vue